import { DataNode } from "../../../interface/Trends";
import { capitalizeFirstLetterAndRemainingSmallForEachWord } from "../../../utils/commonUtils";

type Props = {
  data1?: DataNode | null;
  data2?: DataNode | null;
  tableNo?: number;
};

const ColorAnalysisTable = ({ data1, data2, tableNo }: Props) => {
  let tableData = data1;
  if (data2) tableData = data2;

  if (!tableData) return null;
  return (
    <div className="px-1 pb-8 font-poppins">
      {tableNo && (
        <div className="my-4 flex items-center justify-center font-semibold text-sm text-gray-800">
          Level {tableNo} Analysis Table
        </div>
      )}
      <div className="min-w-full border border-gray-300 bg-white">
        <div className="grid grid-cols-5 border-b border-gray-300 bg-white text-sm font-bold text-gray-800">
          <div className="p-2 border-r border-gray-300 text-center">
            Sr. No.
          </div>
          <div className="p-2 border-r border-gray-300 text-center">
            Color Family
          </div>
          {data2 && (
            <div className="p-2 border-r border-gray-300 text-center">
              Combining Color Family
            </div>
          )}

          <div className="p-2 border-r border-gray-300 text-center">
            Percentage
          </div>
          {data1 && (
            <div className="p-2 border-r border-gray-300 text-center">
              Pantone 1
            </div>
          )}
          {data1 && (
            <div className="p-2 border-r border-gray-300 text-center">
              Pantone 2
            </div>
          )}

          {data2 && (
            <div className="p-2 border-r border-gray-300 text-center">
              Relative Percentage
            </div>
          )}
        </div>
        <div>
          {tableData.children?.map((row, index) => (
            <div
              key={index}
              className="grid grid-cols-5 border-b border-gray-300 text-center"
            >
              <div className="p-2 border-r border-gray-300 text-center text-sm text-gray-700">
                {index + 1}
              </div>
              <div className="p-2 border-r border-gray-300 text-center text-sm text-gray-700">
                {capitalizeFirstLetterAndRemainingSmallForEachWord(
                  data2 ? data2.name : row.name
                )}
              </div>
              {data2 && (
                <div className="p-2 border-r border-gray-300 text-center text-sm text-gray-700">
                  {row?.name}
                </div>
              )}
              <div className="p-2 border-r border-gray-300 text-center text-sm text-gray-700">
                {row?.percentage?.toFixed(2)}
              </div>
              {data1 && (
                <div className="p-2 border-r border-gray-300 text-center text-sm text-gray-700">
                  {row?.pantone1}
                </div>
              )}
              {data1 && (
                <div className="p-2 border-r border-gray-300 text-center text-sm text-gray-700">
                  {row?.pantone2}
                </div>
              )}
              {(data2 || data2) && (
                <div className="p-2 border-r border-gray-300 text-center text-sm text-gray-700">
                  {row?.relativePercentage?.toFixed(3)}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ColorAnalysisTable;
